import { useEffect } from 'react';
import { fetchBrand } from '../../redux/brandSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { Box, CircularProgress } from '@mui/material';
import PortalLogo from '../PortalLogo';

const AppInitializer = ({ children }: { children: React.ReactNode }) => {
	const dispatch = useAppDispatch();
	const { loading } = useAppSelector(s => s.brand);

	useEffect(() => {
		dispatch(fetchBrand());
	}, [dispatch]);

	if (loading)
		return (
			<Box
				height="100vh"
				display="flex"
				flexDirection="column"
				alignItems="center"
				justifyContent="center"
				gap={2}
			>
				{/* Optional logo from brand redux later */}
				<PortalLogo />
				<CircularProgress size={38} />
			</Box>
		);

	return <>{children}</>;
};

export default AppInitializer;
